"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/components/Conversation/Message/FileMessage/FileVideo/ModalView.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _Header = require('web/components/RightSide/Header');








const FileVideoModalView = ({
  videoSrc,
  videoCaption,
  onClose,
  onDownload,
}) => {
  // Not every browser decodes what a phone recorded — HEVC in a .mov being the
  // common case — and the native failure mode is a black rectangle.
  const [canPlay, setCanPlay] = _react.useState.call(void 0, true)

  return (
    _react2.default.createElement(_react2.default.Fragment, null
      , _react2.default.createElement('div', { className: "blm-carousel--header", __self: this, __source: {fileName: _jsxFileName, lineNumber: 24}}
        , _react2.default.createElement('div', { className: "blm-carousel--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 25}},  videoCaption )
        , _react2.default.createElement('div', { className: "blm-carousel--actions", __self: this, __source: {fileName: _jsxFileName, lineNumber: 26}}
          , _react2.default.createElement(_Header.HeaderItem, {
            iconName: "download",
            'aria-label': "Download video" ,
            onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 27}}
          )
          , _react2.default.createElement('div', { className: "blm-carousel--separator", __self: this, __source: {fileName: _jsxFileName, lineNumber: 32}} )
          , _react2.default.createElement(_Header.HeaderItem, {
            iconName: "close",
            'aria-label': "Close video preview"  ,
            onClick: onClose, __self: this, __source: {fileName: _jsxFileName, lineNumber: 33}}
          )
        )
      )
      , _react2.default.createElement('div', { className: "file-image--preview-body", __self: this, __source: {fileName: _jsxFileName, lineNumber: 40}}
        , _react2.default.createElement('div', { className: "file-image--preview-container", __self: this, __source: {fileName: _jsxFileName, lineNumber: 41}}
          ,  canPlay
            ? _react2.default.createElement('video', {
                'data-testid': "file-video-player",
                className: "file-video--preview",
                src: videoSrc,
                controls: true,
                autoPlay: true,
                playsInline: true,
                onError: () => setCanPlay(false), __self: this, __source: {fileName: _jsxFileName, lineNumber: 43}}
              )
            : _react2.default.createElement('div', { className: "file-video--unsupported", __self: this, __source: {fileName: _jsxFileName, lineNumber: 52}}
                , _react2.default.createElement('div', { className: "file-video--unsupported--title", __self: this, __source: {fileName: _jsxFileName, lineNumber: 53}}, "This video can’t be played in your browser"

                )
                , _react2.default.createElement('button', {
                  type: "button",
                  className: "file-video--unsupported--action",
                  onClick: onDownload, __self: this, __source: {fileName: _jsxFileName, lineNumber: 56}}
, "Download"

                )
              )
          
        )
      )
    )
  )
}

exports. default = FileVideoModalView
